module.exports = __webpack_public_path__ + "img/jellybean_tahoe.480984ec.png";